import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import LocalPrintshopRoundedIcon from "@mui/icons-material/LocalPrintshopRounded";
import { saveAs } from "file-saver";
import JSZip from "jszip";
import PDFMerger from "pdf-merger-js/browser";
import print from "print-js";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import CoreDialog from "../../../../../app/core/components/CoreDialog/CoreDialog";
import CoreSpeedDial from "../../../../../app/core/components/CoreSpeedDial/CoreSpeedDial";
import { convertJpgToPdf } from "../../../../../utils/functions/convertInPDF";
import { actions } from "../../gestisciDocumentiSlice";

const GestioneDocumentiButtonCockpit = ({
  deleteDocuments,
  data,
  isDeleteLoading,
}) => {
  const { t } = useTranslation();
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  const dispatch = useDispatch();
  const docManagementState = useSelector((state) => state.docManagementSlice);
  const isSelectedDocsEmpty = docManagementState.selectedDocsIds.length === 0;

  const getLocalFile = (data, Ids) => {
    const files = [];
    data.forEach((doc) => {
      if (Ids.includes(doc.id)) {
        const { extension } = doc.files[0];
        const { name } = doc;
        const url = `${process.env.REACT_APP_API_URL}${doc.files[0].url}`;
        files.push({ url, extension, name });
      }
    });
    return files;
  };

  const confirmDeleteDocuments = () => {
    deleteDocuments(docManagementState.selectedDocsIds).then((res) => {
      if (res.data.Result === 1) {
        dispatch(actions.setSelectedDocsIds([]));
        setOpenDeleteDialog(false);
        toast.success(t("DocsDeleted"));
      } else if (res.data.Exception) {
        toast.error(res.data.Exception);
      }
    });
  };

  const handleDeleteDocuments = () => {
    setOpenDeleteDialog(true);
  };

  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
  };

  const handleDownloadZip = async () => {
    const zip = new JSZip();
    const files = getLocalFile(data, docManagementState.selectedDocsIds);
    const id = toast.loading(t("HandleDownload"), {
      pauseOnFocusLoss: false,
      type: "info",
    });

    for (const file of files) {
      const response = await fetch(file.url);
      const blob = await response.blob();
      zip.file(file.name + "." + file.extension, blob);
    }

    zip.generateAsync({ type: "blob" }).then((content) => {
      saveAs(content, "documents.zip");
      toast.update(id, {
        render: t("DocReady"),
        type: "success",
        isLoading: false,
        autoClose: 1500,
      });
    });
  };

  const handlePrintDocuments = async () => {
    dispatch(actions.setSelectedDocsIds([]));
    const files = getLocalFile(data, docManagementState.selectedDocsIds);
    const merger = new PDFMerger();
    const id = toast.loading(t("HandleDownload"), {
      pauseOnFocusLoss: false,
      type: "info",
    });
    for (const file of files) {
      if (file.extension.toLowerCase() !== "pdf") {
        let convertedBlob = null;
        convertedBlob = await convertJpgToPdf(file.url);
        if (convertedBlob) {
          await merger.add(convertedBlob);
        }
      } else {
        let blob = await fetch(file.url).then((r) => r.blob());
        await merger.add(blob);
      }
    }
    await merger.setMetadata({
      producer: "pdf-merger-js based script",
    });
    const mergedPdf = await merger.saveAsBlob();
    const url = URL.createObjectURL(mergedPdf);
    toast.update(id, {
      render: t("DocReady"),
      type: "success",
      isLoading: false,
      autoClose: 1500,
    });
    print({
      printable: url,
    });
  };

  const multiActions = [
    {
      icon: (
        <DeleteRoundedIcon
          className={isSelectedDocsEmpty ? `fill-gray-200` : `fill-rose-600`}
        />
      ),
      name: t("Delete"),
      onClick: handleDeleteDocuments,
    },

    {
      icon: (
        <DownloadRoundedIcon
          className={isSelectedDocsEmpty ? `text-gray-200` : `fill-blue-700`}
        />
      ),
      name: t("Download"),
      onClick: handleDownloadZip,
    },
    {
      icon: (
        <LocalPrintshopRoundedIcon
          className={isSelectedDocsEmpty ? `text-gray-200` : `fill-black`}
        />
      ),
      name: t("Print"),
      onClick: handlePrintDocuments,
    },
  ];

  return (
    <div className="flex w-full items-center space-x-2">
      <CoreSpeedDial actions={multiActions} selectedDoc={isSelectedDocsEmpty} />

      <CoreDialog
        open={openDeleteDialog}
        title={t("DocsDeleting")}
        content={t("DocsDeletingConfirm")}
        positiveButton={t("Yes")}
        negativeButton={t("No")}
        handlePositive={confirmDeleteDocuments}
        closeDialog={handleCloseDeleteDialog}
        disabledButton={isDeleteLoading}
      />
    </div>
  );
};

export default GestioneDocumentiButtonCockpit;
